// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.iweb-button {
  --color: var(--iweb-colour_primary_info);
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
  height: var(--iweb-btn-height-default);
  line-height: var(--iweb-btn-height-default);
  margin: 0;
  padding: 0 16px;
  font-size: 16px;
  font-weight: 500;
  min-width: 75px;
  text-align: center;
  border: none;
  border-radius: 0;
  cursor: pointer;
  transition: opacity ease 0.15s;
  user-select: none;
  text-decoration: none;
}
.iweb-button::after {
  border-color: transparent;
  border-radius: 0;
}
.iweb-button:focus {
  outline: none;
}
.iweb-button::before {
  position: absolute;
  top: 50%;
  left: 50%;
  width: 100%;
  height: 100%;
  background-color: #fff;
  border: inherit;
  border-color: #fff;
  transform: translate(-50%, -50%);
  opacity: 0;
  content: ' ';
  box-sizing: content-box;
}
.iweb-button:active::before {
  opacity: 0.3;
}
.iweb-button-default {
  color: var(--iweb-colour_primary_info);
}
.iweb-button-default::after {
  border-color: var(--iweb-border-color);
}
.iweb-button-default.iweb-button-fill-outline {
  background-color: transparent;
}
.iweb-button-default.iweb-button-fill-outline::after {
  border-color: var(--iweb-colour_secondary_outline);
}
.iweb-button-default.iweb-button-fill-none {
  background-color: transparent;
}
.iweb-button-default.iweb-button-fill-none::after {
  border-color: transparent;
}
.iweb-button:not(.iweb-button-default).iweb-button-fill-outline {
  color: var(--color);
  background-color: transparent;
  background: none;
}
.iweb-button:not(.iweb-button-default).iweb-button-fill-outline::after {
  border-color: var(--iweb-colour_primary_info);
}
.iweb-button:not(.iweb-button-default).iweb-button-fill-none {
  color: var(--color);
  background-color: transparent;
  background: none;
}
.iweb-button:not(.iweb-button-default).iweb-button-fill-none::after {
  border-color: transparent;
}
.iweb-button-primary {
  --color: var(--iweb-text_white);
  color: var(--iweb-text_white);
  padding: 0 16px;
  background: var(--iweb-brand_gradient);
}
.iweb-button-primary .iweb-button-mask {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: #fff;
  opacity: 0;
}
.iweb-button-primary .iweb-button-mask:hover {
  opacity: 0.1;
}
.iweb-button-secondary {
  --color: var(--iweb-colour_primary_info);
  color: var(--iweb-colour_primary_info);
  border: 1px solid var(--iweb-colour_primary_outline);
  background: none;
}
.iweb-button-secondary .iweb-button-mask {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  background: #000;
  opacity: 0;
}
.iweb-button-secondary .iweb-button-mask:hover {
  opacity: 0.05;
}
.iweb-button-secondary::after {
  border-color: var(--iweb-colour_primary_outline);
}
.iweb-button-link-primary {
  color: var(--iweb-colour_link_info);
  background: none;
  padding: 6px 0;
}
.iweb-button-link-primary .iweb-button-mask {
  display: none;
}
.iweb-button-link-primary::after {
  border: none;
}
.iweb-button-link-secondary {
  color: var(--iweb-colour_primary_info);
  padding: 6px 0;
  border: none;
}
.iweb-button-link-secondary .iweb-button-mask {
  display: none;
}
.iweb-button-link-secondary::after {
  border: none;
}
.iweb-button-disabled {
  cursor: not-allowed;
  background-color: var(--iweb-colour_fill_dimmed);
  color: var(--iweb-colour_quaternary_info);
}
.iweb-button-disabled::after {
  border: none;
}
.iweb-button-disabled:active::before {
  display: none;
}
.iweb-button-large {
  padding: 0 24px;
  height: var(--iweb-btn-height-large);
  line-height: var(--iweb-btn-height-large);
  font-size: 16px;
  min-width: 90px;
}
.iweb-button-small {
  padding: 0 12px;
  height: var(--iweb-btn-height-small);
  line-height: var(--iweb-btn-height-small);
  font-size: 14px;
  min-width: 66px;
}
.iweb-button-xs {
  height: var(--iweb-btn-height-xs);
  line-height: var(--iweb-btn-height-xs);
  padding: 0 8px;
  font-size: 12px;
  min-width: 54px;
}
.iweb-button-block {
  display: block;
  padding: 0 12px;
  font-size: 16px;
  height: var(--iweb-btn-height-large);
  line-height: var(--iweb-btn-height-large);
  width: 100%;
  max-width: 351px;
  margin: 0 auto;
}
.iweb-button-content {
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.iweb-button-icon {
  width: 18px;
  height: 18px;
  line-height: 18px;
  margin-right: 7px;
}
.iweb-button-icon-large,
.iweb-button-icon-medium,
.iweb-button-icon-small,
.iweb-button--icon-xs {
  display: flex;
}
.iweb-button-icon-large .iweb-button-icon {
  width: 21px;
  height: 21px;
  line-height: 21px;
}
.iweb-button-icon-large .i-icon-large {
  font-size: 21px;
}
.iweb-button-icon-medium .iweb-button-icon {
  width: 18px;
  height: 18px;
  line-height: 18px;
}
.iweb-button-icon-medium .i-icon-large {
  font-size: 18px;
}
.iweb-button-icon-small .iweb-button-icon {
  width: 12px;
  height: 12px;
  line-height: 12px;
}
.iweb-button-icon-small .i-icon-large {
  font-size: 12px;
}
.iweb-button-icon-xs .iweb-button-icon {
  width: 10px;
  height: 10px;
  line-height: 10px;
}
.iweb-button-icon-xs .i-icon-large {
  font-size: 10px;
}
.iweb-button-arrow {
  width: 12px;
  margin-left: 6px;
  align-items: center;
  justify-content: center;
  display: flex;
}
`, "",{"version":3,"sources":["webpack://./../../node_modules/@ali/infinite-webui/es/web-components/Button/button.css"],"names":[],"mappings":"AAAA;EACE,wCAAwC;EACxC,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,sBAAsB;EACtB,sCAAsC;EACtC,2CAA2C;EAC3C,SAAS;EACT,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,YAAY;EACZ,gBAAgB;EAChB,eAAe;EACf,8BAA8B;EAC9B,iBAAiB;EACjB,qBAAqB;AACvB;AACA;EACE,yBAAyB;EACzB,gBAAgB;AAClB;AACA;EACE,aAAa;AACf;AACA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,WAAW;EACX,YAAY;EACZ,sBAAsB;EACtB,eAAe;EACf,kBAAkB;EAClB,gCAAgC;EAChC,UAAU;EACV,YAAY;EACZ,uBAAuB;AACzB;AACA;EACE,YAAY;AACd;AACA;EACE,sCAAsC;AACxC;AACA;EACE,sCAAsC;AACxC;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,kDAAkD;AACpD;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,mBAAmB;EACnB,6BAA6B;EAC7B,gBAAgB;AAClB;AACA;EACE,6CAA6C;AAC/C;AACA;EACE,mBAAmB;EACnB,6BAA6B;EAC7B,gBAAgB;AAClB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,+BAA+B;EAC/B,6BAA6B;EAC7B,eAAe;EACf,sCAAsC;AACxC;AACA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,UAAU;AACZ;AACA;EACE,YAAY;AACd;AACA;EACE,wCAAwC;EACxC,sCAAsC;EACtC,oDAAoD;EACpD,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,OAAO;EACP,MAAM;EACN,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,UAAU;AACZ;AACA;EACE,aAAa;AACf;AACA;EACE,gDAAgD;AAClD;AACA;EACE,mCAAmC;EACnC,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,aAAa;AACf;AACA;EACE,YAAY;AACd;AACA;EACE,sCAAsC;EACtC,cAAc;EACd,YAAY;AACd;AACA;EACE,aAAa;AACf;AACA;EACE,YAAY;AACd;AACA;EACE,mBAAmB;EACnB,gDAAgD;EAChD,yCAAyC;AAC3C;AACA;EACE,YAAY;AACd;AACA;EACE,aAAa;AACf;AACA;EACE,eAAe;EACf,oCAAoC;EACpC,yCAAyC;EACzC,eAAe;EACf,eAAe;AACjB;AACA;EACE,eAAe;EACf,oCAAoC;EACpC,yCAAyC;EACzC,eAAe;EACf,eAAe;AACjB;AACA;EACE,iCAAiC;EACjC,sCAAsC;EACtC,cAAc;EACd,eAAe;EACf,eAAe;AACjB;AACA;EACE,cAAc;EACd,eAAe;EACf,eAAe;EACf,oCAAoC;EACpC,yCAAyC;EACzC,WAAW;EACX,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,iBAAiB;AACnB;AACA;;;;EAIE,aAAa;AACf;AACA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;AACA;EACE,eAAe;AACjB;AACA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;AACA;EACE,eAAe;AACjB;AACA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;AACA;EACE,eAAe;AACjB;AACA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;AACA;EACE,eAAe;AACjB;AACA;EACE,WAAW;EACX,gBAAgB;EAChB,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;AACf","sourcesContent":[".iweb-button {\n  --color: var(--iweb-colour_primary_info);\n  position: relative;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  box-sizing: border-box;\n  height: var(--iweb-btn-height-default);\n  line-height: var(--iweb-btn-height-default);\n  margin: 0;\n  padding: 0 16px;\n  font-size: 16px;\n  font-weight: 500;\n  min-width: 75px;\n  text-align: center;\n  border: none;\n  border-radius: 0;\n  cursor: pointer;\n  transition: opacity ease 0.15s;\n  user-select: none;\n  text-decoration: none;\n}\n.iweb-button::after {\n  border-color: transparent;\n  border-radius: 0;\n}\n.iweb-button:focus {\n  outline: none;\n}\n.iweb-button::before {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  width: 100%;\n  height: 100%;\n  background-color: #fff;\n  border: inherit;\n  border-color: #fff;\n  transform: translate(-50%, -50%);\n  opacity: 0;\n  content: ' ';\n  box-sizing: content-box;\n}\n.iweb-button:active::before {\n  opacity: 0.3;\n}\n.iweb-button-default {\n  color: var(--iweb-colour_primary_info);\n}\n.iweb-button-default::after {\n  border-color: var(--iweb-border-color);\n}\n.iweb-button-default.iweb-button-fill-outline {\n  background-color: transparent;\n}\n.iweb-button-default.iweb-button-fill-outline::after {\n  border-color: var(--iweb-colour_secondary_outline);\n}\n.iweb-button-default.iweb-button-fill-none {\n  background-color: transparent;\n}\n.iweb-button-default.iweb-button-fill-none::after {\n  border-color: transparent;\n}\n.iweb-button:not(.iweb-button-default).iweb-button-fill-outline {\n  color: var(--color);\n  background-color: transparent;\n  background: none;\n}\n.iweb-button:not(.iweb-button-default).iweb-button-fill-outline::after {\n  border-color: var(--iweb-colour_primary_info);\n}\n.iweb-button:not(.iweb-button-default).iweb-button-fill-none {\n  color: var(--color);\n  background-color: transparent;\n  background: none;\n}\n.iweb-button:not(.iweb-button-default).iweb-button-fill-none::after {\n  border-color: transparent;\n}\n.iweb-button-primary {\n  --color: var(--iweb-text_white);\n  color: var(--iweb-text_white);\n  padding: 0 16px;\n  background: var(--iweb-brand_gradient);\n}\n.iweb-button-primary .iweb-button-mask {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background: #fff;\n  opacity: 0;\n}\n.iweb-button-primary .iweb-button-mask:hover {\n  opacity: 0.1;\n}\n.iweb-button-secondary {\n  --color: var(--iweb-colour_primary_info);\n  color: var(--iweb-colour_primary_info);\n  border: 1px solid var(--iweb-colour_primary_outline);\n  background: none;\n}\n.iweb-button-secondary .iweb-button-mask {\n  position: absolute;\n  left: 0;\n  top: 0;\n  width: 100%;\n  height: 100%;\n  background: #000;\n  opacity: 0;\n}\n.iweb-button-secondary .iweb-button-mask:hover {\n  opacity: 0.05;\n}\n.iweb-button-secondary::after {\n  border-color: var(--iweb-colour_primary_outline);\n}\n.iweb-button-link-primary {\n  color: var(--iweb-colour_link_info);\n  background: none;\n  padding: 6px 0;\n}\n.iweb-button-link-primary .iweb-button-mask {\n  display: none;\n}\n.iweb-button-link-primary::after {\n  border: none;\n}\n.iweb-button-link-secondary {\n  color: var(--iweb-colour_primary_info);\n  padding: 6px 0;\n  border: none;\n}\n.iweb-button-link-secondary .iweb-button-mask {\n  display: none;\n}\n.iweb-button-link-secondary::after {\n  border: none;\n}\n.iweb-button-disabled {\n  cursor: not-allowed;\n  background-color: var(--iweb-colour_fill_dimmed);\n  color: var(--iweb-colour_quaternary_info);\n}\n.iweb-button-disabled::after {\n  border: none;\n}\n.iweb-button-disabled:active::before {\n  display: none;\n}\n.iweb-button-large {\n  padding: 0 24px;\n  height: var(--iweb-btn-height-large);\n  line-height: var(--iweb-btn-height-large);\n  font-size: 16px;\n  min-width: 90px;\n}\n.iweb-button-small {\n  padding: 0 12px;\n  height: var(--iweb-btn-height-small);\n  line-height: var(--iweb-btn-height-small);\n  font-size: 14px;\n  min-width: 66px;\n}\n.iweb-button-xs {\n  height: var(--iweb-btn-height-xs);\n  line-height: var(--iweb-btn-height-xs);\n  padding: 0 8px;\n  font-size: 12px;\n  min-width: 54px;\n}\n.iweb-button-block {\n  display: block;\n  padding: 0 12px;\n  font-size: 16px;\n  height: var(--iweb-btn-height-large);\n  line-height: var(--iweb-btn-height-large);\n  width: 100%;\n  max-width: 351px;\n  margin: 0 auto;\n}\n.iweb-button-content {\n  max-width: 100%;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n.iweb-button-icon {\n  width: 18px;\n  height: 18px;\n  line-height: 18px;\n  margin-right: 7px;\n}\n.iweb-button-icon-large,\n.iweb-button-icon-medium,\n.iweb-button-icon-small,\n.iweb-button--icon-xs {\n  display: flex;\n}\n.iweb-button-icon-large .iweb-button-icon {\n  width: 21px;\n  height: 21px;\n  line-height: 21px;\n}\n.iweb-button-icon-large .i-icon-large {\n  font-size: 21px;\n}\n.iweb-button-icon-medium .iweb-button-icon {\n  width: 18px;\n  height: 18px;\n  line-height: 18px;\n}\n.iweb-button-icon-medium .i-icon-large {\n  font-size: 18px;\n}\n.iweb-button-icon-small .iweb-button-icon {\n  width: 12px;\n  height: 12px;\n  line-height: 12px;\n}\n.iweb-button-icon-small .i-icon-large {\n  font-size: 12px;\n}\n.iweb-button-icon-xs .iweb-button-icon {\n  width: 10px;\n  height: 10px;\n  line-height: 10px;\n}\n.iweb-button-icon-xs .i-icon-large {\n  font-size: 10px;\n}\n.iweb-button-arrow {\n  width: 12px;\n  margin-left: 6px;\n  align-items: center;\n  justify-content: center;\n  display: flex;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
